import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { useSelector } from "react-redux";
import Emitter from "../../helpers/emitters";

export const useContainerDesktopAnimation = () => {
	const animation = useSelector((state) => state.ui.finishLoader360);
	// const [animation, setAnimation] = useState(false);
	const container = useRef(null);
	const ctx = useRef(null);
	const tl = useRef(null);
	const media = useRef(null);
	const breakPoint = 1092;

	useEffect(() => {
		ctx.current = gsap.context(() => {
			tl.current = gsap.timeline();
			media.current = gsap.matchMedia();
		});
	}, []);
	useEffect(() => {
		media.current.add(
			{
				isDesktop: `(min-width: ${breakPoint}px)`,
				isMobile: `(max-width: ${breakPoint - 1}px)`,
			},
			(context) => {
				const { isDesktop } = context.conditions;
				if (isDesktop) {
					ctx.current.add(() => {
						tl.current
							.set(container.current, {
								xPercent: 150,
							})
							.set(".cardlocationcss", {
								opacity: 0,
							});
					});
				} else {
					ctx.current.add(() => {
						tl.current
							.set(container.current, {
								yPercent: 150,
							})
							.set(".cardlocationcss", {
								opacity: 0,
							});
					});
				}
			}
		);
	}, []);

	useEffect(() => {
		if (animation) {
			media.current.add(
				{
					isDesktop: `(min-width: ${breakPoint}px)`,
					isMobile: `(max-width: ${breakPoint - 1}px)`,
				},
				(context) => {
					const { isDesktop } = context.conditions;
					if (isDesktop) {
						ctx.current.add(() => {
							tl.current
								.to(container.current, {
									xPercent: 0,
									onComplete: () => {
										Emitter.emit("activeInitTutorial");
									},
								})
								.to(".cardlocationcss", {
									opacity: 1,
								});
						});
					} else {
						ctx.current.add(() => {
							tl.current
								.to(container.current, {
									yPercent: 0,
									onComplete: () => {
										Emitter.emit("activeInitTutorial");
									},
								})
								.to(".cardlocationcss", {
									opacity: 1,
								});
						});
					}
				}
			);
		}
	}, [animation]);

	return { container };
};
